import React from 'react';
import './VersionHistory.css';

const VersionHistory = () => {
  return (
    <div className="version-history">
      <h2>PuttPals Versionshistorik</h2>
      
      <div className="version-entry">
        <h3>Version 2.0.0 - 2023-11-15</h3>
        <ul>
          <li>Lanserade nya PuttPals med omdesignat gränssnitt</li>
          <li>Lade till mörkt och ljust tema</li>
          <li>Förbättrade prestanda och responsivitet</li>
          <li>Lade till möjlighet att lägga till spelare och banor</li>
        </ul>
      </div>
      
      <div className="version-entry">
        <h3>Version 1.5.0 - 2023-09-10</h3>
        <ul>
          <li>Förbättrade statistikvyn med nya diagram</li>
          <li>Fixade buggar i poängberäkningen</li>
          <li>Optimerade databasen för bättre prestanda</li>
        </ul>
      </div>
      
      <div className="version-entry">
        <h3>Version 1.0.0 - 2023-06-01</h3>
        <ul>
          <li>Initial lansering av PuttPals</li>
          <li>Grundläggande funktionalitet för att spåra discgolf-rundor</li>
          <li>Stöd för spelarstatistik och rankingar</li>
        </ul>
      </div>
    </div>
  );
};

export default VersionHistory; 